import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getDailyReportsShiftSummaries({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_DAILY_REPORTS_SHIFT_SUMMARIES_REQUEST')

        return axios
            .get(`/reports/reports-shift-summaries${paginate}${query}`)
            .then(response => {
                commit('GET_DAILY_REPORTS_SHIFT_SUMMARIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DAILY_REPORTS_SHIFT_SUMMARIES_FAILURE')
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDailyShipmentsReportsShiftSummaries({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_REQUEST')

        return axios
            .get(`/shipments/shipments-reports-shift-summaries${paginate}${query}`)
            .then(response => {
                commit('GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DAILY_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_FAILURE')
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateShiftSummariesReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/reports-shift-summaries?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setDailyReportsShiftSummariesFilters({ commit }, filters) {
        commit('SET_DAILY_REPORTS_SHIFT_SUMMARIES_FILTERS', filters)
    },
    clearDailyReportsShiftSummariesFilters({ commit }) {
        commit('CLEAR_DAILY_REPORTS_SHIFT_SUMMARIES_FILTERS')
    },
    clearDailyReportsShiftSummaries({ commit }) {
        commit('CLEAR_DAILY_REPORTS_SHIFT_SUMMARIES')
    },
    setUser({ commit }, data) {
        commit('SET_USER', data)
    },
    clearUser({ commit }) {
        commit('CLEAR_USER')
    }
}